import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';

@Injectable({
  providedIn: 'root'
})
export class AesCryptoService {

  private get kk(): string {
    return CryptoJS.enc.Utf8.parse("Z4NMqZEvvScXIxwk");
  }

  private get ii(): string {
    return CryptoJS.enc.Utf8.parse("vg96EmbXrpPSICat");
  }

  constructor() { }
  encrypt(data: string) {
    return CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(data), this.kk, { iv: this.ii }).toString();
  }  
  
  // encrpt(data: string) {
  //   return CryptoJS.AES.encrypt(data, this.kk, { iv: this.ii }).toString();
  // }

  decrpt(raw: string) {
     
    let decData = CryptoJS.AES.decrypt(raw, this.kk, { iv: this.ii }).toString(CryptoJS.enc.Utf8);
    return JSON.parse(decData);
  }

  encryptedString(str: string): { req: string, token: string } {
    const str2 = (str.length / 2) - 1;
    const str3 = (Number(str2) > 10) ? 10 : str2;
    const res = str.substr(str2, str3);
    const newStringArray = str.split('');
    newStringArray.splice(str2, str3)
    var obj =
    {
      req: newStringArray.join(''),
      token: res
    }
    return obj;
  }

}